import { createAsyncThunk } from "@reduxjs/toolkit";
import { getAppsUrl, updateAppsUrl } from "store/services/dataManagement/getTheApps";
import { openToast } from "store/slices/common/toast.slice";
import { getApiMessage } from "utils/apiErrorCode";

// Get Apps Url
export const GetAppsUrlAction = createAsyncThunk(
  "apps/get",
  async (payload, { rejectWithValue, fulfillWithValue }) => {
    try {
      const res = await getAppsUrl(payload);
      if (res.status === 1) {
        return fulfillWithValue(res);
      }
      return rejectWithValue(res);
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const UpdateAppsUrlAction = createAsyncThunk(
  "apps/edit",
  async (payload, { rejectWithValue, dispatch, fulfillWithValue }) => {
    const { onSuccess, onError, ...rest } = payload;
    try {
      const res = await updateAppsUrl(rest);
      if (res.status === 1) {
        if (onSuccess) {
          onSuccess();
        }
        return fulfillWithValue(res);
      }
      if (onError) {
        onError();
      }
      dispatch(
        openToast({ type: "error", message: getApiMessage(res?.statusCode) }),
      );
      return rejectWithValue(res);
    } catch (error) {
      dispatch(
        openToast({
          type: "error",
          message: error?.response?.data?.statusCode
            ? getApiMessage(error?.response?.data?.statusCode)
            : error?.message,
        }),
      );
      if (onError) {
        onError();
      }
      return rejectWithValue(error);
    }
  },
);